import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import NewsletterSection from "@/pages/home/components/NewsletterSection";
import NewsSubmissionCTA from "@/components/feature/NewsSubmissionCTA";
import SEO from "@/components/SEO";

const topAirlines = [
  { airline: "American Airlines", share: 18, pax: "3.98M", routes: "SDQ, PUJ, POP, STI, LRM", hub: "Miami / Dallas" },
  { airline: "JetBlue Airways", share: 14, pax: "3.09M", routes: "SDQ, PUJ, POP, STI, AZS", hub: "JFK / Boston / FLL" },
  { airline: "Delta Air Lines", share: 9, pax: "1.99M", routes: "SDQ, PUJ, POP", hub: "Atlanta" },
  { airline: "United Airlines", share: 7, pax: "1.55M", routes: "SDQ, PUJ, POP", hub: "Newark / Houston" },
  { airline: "Spirit Airlines", share: 6, pax: "1.33M", routes: "SDQ, PUJ, POP", hub: "FLL / Orlando" },
  { airline: "Copa Airlines", share: 5, pax: "1.10M", routes: "SDQ, PUJ, STI", hub: "Panamá (PTY)" },
  { airline: "Iberia", share: 4, pax: "884K", routes: "SDQ, PUJ", hub: "Madrid" },
  { airline: "Arajet", share: 4, pax: "884K", routes: "Todos los destinos", hub: "Santo Domingo (SDQ)" },
];

const domesticRoutes = [
  { route: "SDQ ↔ PUJ", distance: "140 km", freq: "12x/día", airline: "Arajet / Air Century" },
  { route: "SDQ ↔ STI", distance: "130 km", freq: "8x/día", airline: "Arajet / Copa" },
  { route: "SDQ ↔ POP", distance: "170 km", freq: "4x/día", airline: "Arajet / Air Century" },
  { route: "SDQ ↔ AZS", distance: "105 km", freq: "2x/día", airline: "Arajet" },
  { route: "SDQ ↔ BRX", distance: "195 km", freq: "1x/día", airline: "Sky Cana" },
  { route: "PUJ ↔ STI", distance: "250 km", freq: "2x/día", airline: "Arajet" },
];

const aircraftTypes = [
  { type: "Boeing 737 MAX", count: 28, airlines: "Arajet, American, United, Copa", share: 22 },
  { type: "Airbus A320neo/A321", count: 24, airlines: "JetBlue, Spirit, Iberia", share: 19 },
  { type: "Boeing 787 Dreamliner", count: 16, airlines: "JetBlue, LATAM, Air Europa", share: 13 },
  { type: "Airbus A330", count: 12, airlines: "Iberia, Air Europa, Delta", share: 10 },
  { type: "ATR 72 / Dash 8", count: 10, airlines: "Air Century, Sky Cana", share: 8 },
  { type: "Boeing 757/767", count: 8, airlines: "United, Delta", share: 6 },
];

const monthlyPaxData = [
  { month: "Ene", value: 1.9 },
  { month: "Feb", value: 1.8 },
  { month: "Mar", value: 2.1 },
  { month: "Abr", value: 1.6 },
  { month: "May", value: 1.4 },
  { month: "Jun", value: 1.7 },
  { month: "Jul", value: 2.2 },
  { month: "Ago", value: 2.0 },
  { month: "Sep", value: 1.3 },
  { month: "Oct", value: 1.5 },
  { month: "Nov", value: 1.8 },
  { month: "Dic", value: 2.3 },
];
const maxMonthly = Math.max(...monthlyPaxData.map((d) => d.value));

export default function EstadisticasAerolineas() {
  return (
    <main className="min-h-screen bg-[#071529]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <SEO
        jsonLdSchemas={[
          {
            "@type": "WebPage",
            name: "Estadísticas de Aerolíneas",
            description: "Conectividad aérea, rutas, flota y tráfico por aerolínea en República Dominicana.",
            url: 'https://aviacioninsightrd.com/estadisticas-aerolineas',
          },
        ]}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 overflow-hidden">
        <div className="absolute inset-0 opacity-5" style={{ backgroundImage: "linear-gradient(#3b82f6 1px, transparent 1px), linear-gradient(90deg, #3b82f6 1px, transparent 1px)", backgroundSize: "48px 48px" }} />
        <div className="max-w-screen-xl mx-auto px-4 md:px-6 relative z-10">
          <div className="flex items-center gap-2 mb-4">
            <Link to="/aerolineas" className="text-blue-400 text-sm hover:text-blue-300 cursor-pointer">Aerolíneas</Link>
            <i className="ri-arrow-right-s-line text-blue-600" />
            <span className="text-slate-400 text-sm">Estadísticas</span>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
            <div>
              <div className="flex items-center gap-2 bg-blue-600/20 border border-blue-500/30 rounded-full px-3 py-1 w-fit mb-3">
                <span className="w-2 h-2 bg-blue-400 rounded-full animate-pulse" />
                <span className="text-blue-300 text-[10px] font-bold tracking-widest uppercase">Datos JAC · IDAC · Actualizado abr. 2026</span>
              </div>
              <h1 className="text-white font-bold" style={{ fontFamily: "'Sora', sans-serif", fontSize: "clamp(2rem, 5vw, 3rem)" }}>
                ESTADÍSTICAS DE AEROLÍNEAS
              </h1>
              <p className="text-blue-200/60 text-sm mt-2">Conectividad aérea, rutas, flota y tráfico por aerolínea en República Dominicana</p>
            </div>
            <Link
              to="/aerolineas"
              className="flex-shrink-0 flex items-center gap-2 px-5 py-3 bg-blue-600 hover:bg-blue-500 text-white font-semibold text-sm rounded-lg transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line" />
              Volver a Aerolíneas
            </Link>
          </div>
        </div>
      </section>

      {/* Monthly traffic + aircraft types */}
      <section className="pb-10">
        <div className="max-w-screen-xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Monthly traffic */}
            <div className="lg:col-span-2 bg-white/5 border border-white/8 rounded-xl p-6">
              <h3 className="text-white font-bold mb-1" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "1.1rem" }}>
                TRÁFICO MENSUAL DE PASAJEROS 2025
              </h3>
              <p className="text-slate-500 text-xs mb-5">Millones de pasajeros por mes · Tráfico total aerocomercial</p>
              <div className="flex items-end gap-1.5 h-32">
                {monthlyPaxData.map((d) => {
                  const height = Math.round((d.value / maxMonthly) * 100);
                  const isPeak = d.value >= 2.0;
                  return (
                    <div key={d.month} className="flex-1 flex flex-col items-center gap-1 group">
                      <div className="w-full relative flex items-end" style={{ height: "110px" }}>
                        <div className="absolute bottom-0 left-0 right-0 w-full rounded-t-sm transition-colors" style={{ height: `${height}%`, background: isPeak ? "#f59e0b" : "#1d4ed8" }} />
                      </div>
                      <span className="text-slate-500 text-[9px]">{d.month}</span>
                    </div>
                  );
                })}
              </div>
              <div className="mt-4 pt-4 border-t border-white/10 flex gap-4">
                <div className="flex items-center gap-1.5">
                  <div className="w-2.5 h-2.5 rounded-sm bg-amber-500" />
                  <span className="text-slate-400 text-[10px]">Temporada alta</span>
                </div>
                <div className="flex items-center gap-1.5">
                  <div className="w-2.5 h-2.5 rounded-sm bg-blue-700" />
                  <span className="text-slate-400 text-[10px]">Temporada regular</span>
                </div>
              </div>
            </div>

            {/* Aircraft types */}
            <div className="bg-white/5 border border-white/8 rounded-xl p-6">
              <h3 className="text-white font-bold mb-5" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "1.1rem" }}>
                TIPOS DE AERONAVES EN RD
              </h3>
              <div className="space-y-4">
                {aircraftTypes.map((a, i) => (
                  <div key={a.type}>
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-slate-300 text-xs">{a.type}</span>
                      <div className="flex items-center gap-2">
                        <span className="text-white text-xs font-semibold">{a.count}</span>
                        <span className="text-slate-500 text-[10px]">{a.share}%</span>
                      </div>
                    </div>
                    <div className="h-1.5 bg-white/10 rounded-full overflow-hidden">
                      <div className="h-full rounded-full" style={{ width: `${a.share * 2}%`, background: i === 0 ? "#3b82f6" : "#1d4ed8", opacity: 1 - i * 0.1 }} />
                    </div>
                    <p className="text-slate-500 text-[10px] mt-1">{a.airlines}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Top airlines + domestic routes */}
      <section className="pb-10">
        <div className="max-w-screen-xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Top airlines */}
            <div className="lg:col-span-2 bg-white/5 border border-white/8 rounded-xl p-6">
              <h3 className="text-white font-bold mb-1" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "1.1rem" }}>
                AEROLÍNEAS POR CUOTA DE MERCADO
              </h3>
              <p className="text-slate-500 text-xs mb-5">Participación en pasajeros totales · 2025</p>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-white/10">
                      {["Aerolínea", "Rutas en RD", "Hub", "Cuota", "Pasajeros"].map((h, i) => (
                        <th key={h} className={`text-slate-400 text-xs pb-3 font-semibold ${i >= 3 ? "text-right" : "text-left"}`}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {topAirlines.map((r, i) => (
                      <tr key={r.airline} className={`border-b border-white/5 hover:bg-white/5 transition-colors ${i === 0 ? "bg-blue-600/10" : ""}`}>
                        <td className="py-3">
                          <div className="flex items-center gap-2">
                            <span className="text-white font-bold text-sm" style={{ fontFamily: "'Sora', sans-serif" }}>{r.airline}</span>
                          </div>
                        </td>
                        <td className="py-3 text-slate-400 text-xs max-w-[160px] truncate">{r.routes}</td>
                        <td className="py-3 text-slate-400 text-xs">{r.hub}</td>
                        <td className="py-3 text-right">
                          <div className="flex items-center justify-end gap-2">
                            <div className="w-16 h-1.5 bg-white/10 rounded-full overflow-hidden">
                              <div className="h-full rounded-full bg-blue-500" style={{ width: `${(r.share / 18) * 100}%` }} />
                            </div>
                            <span className="text-slate-300 text-xs">{r.share}%</span>
                          </div>
                        </td>
                        <td className="py-3 text-right">
                          <span className="text-blue-400 font-bold text-sm" style={{ fontFamily: "'Sora', sans-serif" }}>{r.pax}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Domestic routes */}
            <div className="bg-white/5 border border-white/8 rounded-xl p-6">
              <h3 className="text-white font-bold mb-5" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "1.1rem" }}>
                RUTAS DOMÉSTICAS MÁS TRANSITADAS
              </h3>
              <div className="space-y-3">
                {domesticRoutes.map((r) => (
                  <div key={r.route} className="py-2 border-b border-white/5">
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-white text-sm font-semibold" style={{ fontFamily: "'Sora', sans-serif" }}>{r.route}</span>
                      <span className="text-blue-400 text-xs font-semibold">{r.freq}</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-slate-500 text-[10px]">{r.distance} · {r.airline}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Source */}
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 pb-10">
        <p className="text-slate-600 text-xs">
          <i className="ri-information-line mr-1" />
          Fuente: <strong className="text-slate-500">Junta de Aviación Civil (JAC)</strong>, <strong className="text-slate-500">IDAC</strong>, <strong className="text-slate-500">IATA</strong> · Datos actualizados al 30 de abril de 2026.
        </p>
      </div>

      <div className="max-w-screen-xl mx-auto px-4 md:px-6 pb-8">
        <NewsSubmissionCTA
          variant="light"
          title="¿Tienes datos del sector aéreo?"
          description="Si trabajas en una aerolínea o entidad aeronáutica y tienes estadísticas o reportes, compártelos con nuestra audiencia."
        />
      </div>

      <NewsletterSection />
      <Footer />
    </main>
  );
}